<template>
    <div>
        <q-slide-transition>
            <div class='fixed-bottom-right text-center q-pa-sm btn-block shadow-2' v-if='isPayButtonVisible' style='margin-right:45px;'>
                <div><q-btn label='чек-лист' color='positive' size='md' icon='far fa-check-circle' @click='showCheckDialog' class='q-ma-sm' style='width:200px'/></div>
                <div><q-btn label='оплата' color='negative' size='md' icon='save_alt' @click='showBillDialog'  class='q-ma-sm'  style='width:200px'/></div>
            </div>
        </q-slide-transition>

        <q-slide-transition>
            <div class='fixed-top-left text-center q-pa-sm btn-block shadow-2 q-ml-sm' v-if='isPayButtonVisible' style=' margin-top:58px; z-index:3;'>
                <div><q-btn color='negative' size='sm' dense icon='far fa-check-circle' @click='clearSelected'/></div>
            </div>
        </q-slide-transition>


        <designer-dialog/>
        <bill-dialog/>
        
        <main-edit-dialog/>
        <manager-info/>
        <!-- тут надо сделать кнопку -->
        <div class='row no-wrap justify-between q-ma-lg q-pb-md q-pl-md' v-bind:class="{'filter-mark':isFilter}" >
            <div class='row wrap items-baseline '>
                <q-select
                    name = "filter_contragent"
                    v-model=filter_contragent
                    float-label="Фильтр: Заказчик"
                    filter
                    clearable
                    radio
                    autofocus-filter
                    filter-placeholder = "Фильтр"
                    :options="getContragents"
                    separator
                    style="min-width:250px"
                    class='q-ma-xs'
                />
                <!-- @input="changeContragentFilter" -->
                <q-select
                    name = "filter_executor"
                    v-model=filter_executor
                    float-label="Фильтр: Исполнитель"
                    filter
                    clearable
                    radio
                    autofocus-filter
                    filter-placeholder = "Фильтр"
                    :options="getExecutors"
                    separator
                    style="min-width:250px;"
                    class='q-ma-xs'
                />
                <q-select
                    name = "filter_payStatus"
                    v-model=filter_payStatus
                    float-label="Фильтр: Статус оплаты"
                    filter
                    clearable
                    radio
                    autofocus-filter
                    filter-placeholder = "Фильтр"
                    :options="[
                        {label : 'Без оплаты', value : 0},
                        {label : 'Частичная оплата', value : 1},
                        {label : 'Оплачено', value : 2}
                    ]"
                    separator
                    style="min-width:250px;"
                    class='q-ma-xs'
                />

                <!-- <q-checkbox 
                    v-model="filter_manager" 
                    color="secondary" 
                    label="Только мои заказы" 
                    style='margin-left:25px;' 
                    @input="changeMyFilter"
                /> -->
            </div>

            <!-- <q-btn icon='save_alt' label='Оплата' color='positive' size='lg' @click='showBillDialog'/> -->
        </div>
        <!-- тут надо сделать кнопку -->

        <designer-orders/>
        <check-orders />
        <in-work-orders />
        <ready-orders/>
        <checkDialog/>
        <checkOrderDialog/>

        <!-- диалог дозагрузки файлов в облако -->
        <cloud-upload-dialog></cloud-upload-dialog>
        
    </div>
</template>
<script>
/* eslint-disable */

import DesignerOrders from './DesignerOrders';
import upload from './upload';
import CheckOrders from './CheckOrders'
import InWorkOrders from './InWorkOrders'
import readyOrders from './readyOrders'

import DesignerDialog from './designerDialog'
import mainEditDialog from './mainEditDialog'
import billDialog from './billDialog'
import cloudUploadDialog from './cloudUploadDialog'
import managerInfo from './../informers/managerInfo'
import checkDialog from './checkListDialog'
import checkOrderDialog from './mainDialog/checkOrderDialog'


export default {
  name:'order-list',
  
  data () {
            return {
                // filter_contragent : null,
                filter_manager : false,
                // filter_executor : null,
            }
  },
  components :{

      DesignerOrders,
      CheckOrders,
      DesignerDialog,
      mainEditDialog,
      InWorkOrders,
      readyOrders,
      billDialog,
      cloudUploadDialog,
      managerInfo,
      checkDialog,
      checkOrderDialog,

  },
 
  created() {
      this.$store.dispatch('retrieveOrders')
      .then(()=>{
          
      })
      .catch(errorCode =>{ // если не авторизован - то выкидываем на страницу авторизации
        //   if (errorCode == 401) {
        //       this.$router.push('logout')
        //   }
      });

      this.$store.dispatch('retrieveContragents')
      .then()
      .catch(errorCode => {
        //   if (errorCode == 401) {
        //       this.$router.push('logout')
        //   }
      });

      this.$store.dispatch('retrieveUsers')
      .then()
      .catch(errorCode=>{
        //   if (errorCode == 401) {
        //       this.$router.push('logout')
        //   }
      });

      eventBus.$on('deleteOrder', (order)=>{
            
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Пожалуйста, подтвердите удаление заказа №'+order.id,
                ok: 'Удалить заказ',
                cancel: 'Отмена'
            }).then( ()=> {
                this.deleteOrder(order);
            });
      });

      if (this.$store.getters.getAllExecutors.length == 0) { // если список исполнителей пуст - то пробуем его загрузить
         this.$store.dispatch('getAllExecutors')
         .then()
         .catch( errorCode => {
        //   if (errorCode == 401) {
        //       this.$router.push('logout')
        //   }
         });
      }
      
  },

  beforeDestroy() {
       eventBus.$off('deleteOrder');
  },

  computed: {

        isFilter() {
            let result = this.$store.getters.getFilterPayStatus!=null;
            result = result || (this.$store.getters.getFilterContragent!=null);
            result = result || (this.$store.getters.getFilterExecutor!=null);
            return result;
        },

        isPayButtonVisible() {
            return this.$store.getters.getSelectedOrders.length > 0;
        },

        filter_payStatus : {
            get : function() {
                 return this.$store.getters.getFilterPayStatus;
            },
            set : function(newValue) {
                this.$store.commit('setPayStatusFilter', newValue)
            }
        },
        filter_contragent: {
            get: function () {
                return this.$store.getters.getFilterContragent;
            },
            set: function (newValue) {
                this.$store.commit('setContragentFilter', newValue)
            }
        },
        filter_executor: {
            get: function () {
                return this.$store.getters.getFilterExecutor;
            },
            set: function (newValue) {
                this.$store.commit('setExecutorFilter', newValue)
            }
        },

        main_info() {
            return this.$store.getters.allContragents;
        },
        
        getContragents() {
            var list = [];
            if (this.$store.getters.allContragents==undefined) return list;
            this.$store.getters.allContragents.map((value,key)=>{
                list.push({label:value.name, value:value.id});
            });
            return list.sort((a, b)=>{              /// отдаем отсортированный массив
                 if (a.label < b.label) return -1;
                 if (a.label > b.label) return 1;
                 if (a.label == b.label) return 0;
            });

        },

        getExecutors() {
            var list = [];
            if (this.$store.getters.getAllExecutors==undefined) return list;
            this.$store.getters.getAllExecutors.map((value,key)=>{
                list.push({label:value.name, value:value.id});
            });
            return list;
        },


        getManagers() {
            var list = [];
            if (this.$store.getters.allUsers==undefined) return list;
            this.$store.getters.allUsers.map((value,key)=>{
                list.push({label:value.name+" "+value.surname, value:value.id});
            });
            return list;
        },

  },

  methods : {

      clearSelected() {
          this.$store.commit('clearSelectedOrders');
      },

      showCheckDialog() {
         eventBus.$emit('checkListDialog');  
      },

      changeMyFilter(val) {
         this.$store.commit('setManagerFilter', val);
      },

      initShowDialog(billNum = null) { // показываем диалоговое окно редактирования счета/оплат

        this.$store.dispatch('lockOrders', this.$store.getters.getSelectedOrders) // блокируем все используемые записи разом
        .then(()=>{ // если заблокировалось успешно - то выводим диалоговое окно
            eventBus.$emit('openBillDialog', billNum);
        })
        .catch(error => {
            console.log(error);
            this.$admns.showNotify('Не удалось заблокировать записи','error','Сообщение системы')
        });

      },

      showBillDialog() {
// проверка на привязку к более чем одному счету
        let q = this.$store.getters.getSelectedOrders; // получаем весь выделенный массив данных
        let bills = [];
        let nullBills = [];
        let sameContragent = true;
        let oldContragent = null;
        if (q.length>1) { // если число элементов больше 1 - то значит нужно проверить
            q.forEach(element => {
                let order = this.$store.getters.getOrderById(element); // получили выделенный заказ
                if (oldContragent == null) oldContragent = order.contragent; // проверка на одинакового контрагента
                if (oldContragent != order.contragent) sameContragent = false;

                if (order.bill_out==null) nullBills.push(order.id); //если не задан счет - то добавлям в массив

                if ((order.bill_out != undefined)&&(bills.indexOf(order.bill_out)==-1)) {
                    bills.push(order.bill_out);
                }
            });
            if (bills.length>1) { // если число уникальных привязок больше ччем 1 - то выдаем ошибку
                this.$q.dialog({
                    title : 'Ошибка!',
                    message: 'Выделенные заказы привязаны к разным счетам',
                    color : 'negative',
                    ok : true,
                    preventClose : false
                });
                return;
            }
        }
        if (q.length == 0) { //заказы не выделены - выходим нахер
            this.$q.dialog({
                title : 'Внимание!',
                message: 'Нужно выделить заказы, которые будут включены в счет.',
                color : 'negative',
                ok : true,
                preventClose : false
            });
            return;
        }

        if (!sameContragent) { // если заказы не одного контрагента - то выходим нахер
                this.$q.dialog({
                    title : 'Ошибка!',
                    message: 'Выделены заказы разных контрагентов',
                    color : 'negative',
                    ok : true,
                    preventClose : false
                });
                return;
        }
        if ((oldContragent != null) && (nullBills.length>0)) { // значит есть нулевые счета и пробуем их привязать к существующим

            let st = ''
            nullBills.forEach(element => {
                st += element+',';
            });

           st =  st.slice(0, st.length-1); 
           let st1 = nullBills.length>1 ? 'К заказам №№ ' : 'К заказу №';

            this.$q.dialog({
                    title : 'Внимание!',
                    message: st1+st + ' не присвоен счет. Объеденить заказы в общий счет?',
                    color : 'positive',
                    ok : 'Да, объеденить',
                    cancel : 'Нет',
                    preventClose : false
            })
            .then(() => {
                
                this.$store.dispatch('combineBills')
                .then( (orders)=> {
                    let order = orders.length > 0 ? orders[0] : null;
                    this.initShowDialog(order);
                })
                .catch();
                
            })
            .catch(() => {
                console.log('Отмена')
                return;
            })
            console.log('Есть нулевые счета в заказах: '+st);
        } else  {  // значит выделена одна запись - надо загрузить ее
            let order = this.$store.getters.getOrderById(q[0]); // получили выделенный заказ
            this.initShowDialog(order);
        }

      },

      showNotify(nMessage, nType, detail='') {

          this.$admns.showNotify(nMessage, nType, detail);

      },


      deleteOrder(order) {
     
        this.$store.dispatch('deleteOrder', order)
        .then( () => {
            this.showNotify('Заказ успешно удален', 'success')
        })
        .catch( ()=> {
            this.showNotify('Ошибка при удалении заказа', 'error')
        });

      },

  }, //methods

}
</script>

<style lang="scss" scoped>
    .filter-mark {
        border : 2px solid red;
    }
    .btn-block {
        background: rgba(126, 126, 126, 0.5);
    }
</style>
